// extracted by mini-css-extract-plugin
export default {"promo":"Advert_promo__r3BkD"};